import {
  useCreateNewVersionNoteToFileMutation,
  useCreateNoteToFileMutation,
  useGetAllNoteToFileMutation,
  useLazyGetNoteToFileQuery,
  useNoteToFilePublishToETMFMutation,
  useNoteToFilePublishToISFMutation,
  useSignNoteToFileMutation,
  useUpdateNoteToFileMutation
} from 'src/services/NoteToFile';

export const useNoteToFile = () => {
  const [
    getAllNoteToFile,
    {
      data: getAllNoteToFileData,
      error: getAllNoteToFileError,
      isError: getAllNoteToFileIsError,
      isLoading: getAllNoteToFileIsLoading,
      isSuccess: getAllNoteToFileIsSuccess
    }
  ] = useGetAllNoteToFileMutation();

  const [
    getNoteToFileData,
    {
      data: noteToFileData,
      error: noteToFileError,
      isError: noteToFileIsError,
      isLoading: noteToFileIsLoading,
      isSuccess: noteToFileIsSuccess
    }
  ] = useLazyGetNoteToFileQuery();

  const [
    createNoteToFile,
    {
      data: createNoteToFileData,
      error: createNoteToFileError,
      isError: createNoteToFileIsError,
      isLoading: createNoteToFileIsLoading,
      isSuccess: createNoteToFileIsSuccess
    }
  ] = useCreateNoteToFileMutation();
  const [
    updateNoteToFile,
    {
      data: updateNoteToFileData,
      error: updateNoteToFileError,
      isError: updateNoteToFileIsError,
      isLoading: updateNoteToFileIsLoading,
      isSuccess: updateNoteToFileIsSuccess
    }
  ] = useUpdateNoteToFileMutation();

  const [
    noteToFileSign,
    {
      data: noteToFileSignData,
      error: noteToFileSignError,
      isError: noteToFileSignIsError,
      isLoading: noteToFileSignIsLoading,
      isSuccess: noteToFileSignIsSuccess
    }
  ] = useSignNoteToFileMutation();

  const [
    createNewNoteToFileVersion,
    {
      data: createNewNoteToFileVersionData,
      error: createNewNoteToFileVersionError,
      isError: createNewNoteToFileVersionIsError,
      isLoading: createNewNoteToFileVersionIsLoading,
      isSuccess: createNewNoteToFileVersionIsSuccess
    }
  ] = useCreateNewVersionNoteToFileMutation();

  const [
    noteToFilePublishToISF,
    {
      data: noteToFilePublishToIsfData,
      error: noteToFilePublishToIsfError,
      isError: noteToFilePublishToIsfIsError,
      isLoading: noteToFilePublishToIsfIsLoading,
      isSuccess: noteToFilePublishToIsfIsSuccess
    }
  ] = useNoteToFilePublishToISFMutation();

  const [
    noteToFilePublishToETMF,
    {
      data: noteToFilePublishToEtmfData,
      error: noteToFilePublishToEtmfError,
      isError: noteToFilePublishToEtmfIsError,
      isLoading: noteToFilePublishToEtmfIsLoading,
      isSuccess: noteToFilePublishToEtmfIsSuccess
    }
  ] = useNoteToFilePublishToETMFMutation();

  return {
    getAllNoteToFileData,
    getAllNoteToFileError,
    getAllNoteToFileIsError,
    getAllNoteToFileIsLoading,
    getAllNoteToFileIsSuccess,
    getAllNoteToFile,
    noteToFileData,
    noteToFileError,
    noteToFileIsError,
    noteToFileIsLoading,
    noteToFileIsSuccess,
    getNoteToFileData,
    createNoteToFileData,
    createNoteToFileError,
    createNoteToFileIsError,
    createNoteToFileIsLoading,
    createNoteToFileIsSuccess,
    createNoteToFile,
    updateNoteToFileData,
    updateNoteToFileError,
    updateNoteToFileIsError,
    updateNoteToFileIsLoading,
    updateNoteToFileIsSuccess,
    updateNoteToFile,
    noteToFileSignData,
    noteToFileSignError,
    noteToFileSignIsError,
    noteToFileSignIsLoading,
    noteToFileSignIsSuccess,
    noteToFileSign,
    createNewNoteToFileVersionData,
    createNewNoteToFileVersionError,
    createNewNoteToFileVersionIsError,
    createNewNoteToFileVersionIsLoading,
    createNewNoteToFileVersionIsSuccess,
    createNewNoteToFileVersion,
    noteToFilePublishToIsfData,
    noteToFilePublishToIsfError,
    noteToFilePublishToIsfIsError,
    noteToFilePublishToIsfIsLoading,
    noteToFilePublishToIsfIsSuccess,
    noteToFilePublishToISF,
    noteToFilePublishToEtmfData,
    noteToFilePublishToEtmfError,
    noteToFilePublishToEtmfIsError,
    noteToFilePublishToEtmfIsLoading,
    noteToFilePublishToEtmfIsSuccess,
    noteToFilePublishToETMF
  };
};
